import { APIVersion, axios } from "../../Config/config.js";
const sharedBaseUrl = "https://shared.dev.silal.app";
// axios.defaults.baseURL = basePath;
const getTemplateListings = async (payload) => {
  return await axios.get(
    `${APIVersion}paginate_templates/?detailed=T`,
    payload
  );
};
const createListingTemplates = async (payload) => {
  return await axios.post(`${APIVersion}templates/`, payload);
};

const updateListingTemplates = async (payload) => {
  return await axios.post(`${APIVersion}templates/`, payload.id);
};
const getCategoriesWithInheritedAttributesByCategoryId = async (
  category_id
) => {
  return await axios.get(
    `${sharedBaseUrl}${APIVersion}categories/${category_id}/`
  );
};

const deleteTemplate = async (payload) => {
  return await axios.delete(`${APIVersion}templates/${payload}`);
};
export {
  updateListingTemplates,
  deleteTemplate,
  getTemplateListings,
  createListingTemplates,
  getCategoriesWithInheritedAttributesByCategoryId,
};
